export default class RequestBase {
    Validate() {
        if (this.url === undefined ||
            this.method === undefined ||
            (this.method === 'POST' && this.parameters === undefined)) {
            return false;
        }
        return true;
    }

    get url() {
        var regexp = /\{([A-Za-z0-9]+)\}/gi;
        var url = this._url;
        var match = null;
        var valueToReplace;

        do {
            match = regexp.exec(url);

            if (match != null) {
                valueToReplace = this[match[1]];
                url = url.replace(match[0], valueToReplace);
            }
        } while (match != null);

        return url;
    }
}



// WEBPACK FOOTER //
// ./src/Resources/RequestBase.js